import React from 'react';

import {
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  coreSelectors,
} from '@gymcloud/core';

import {
  getUiState,
  getSidebarProFolders,
  getSidebarClientFolders,
} from 'web-selectors';

import {
  uiActions,
} from 'web-actions';

import {
  Sidebar,
} from 'web-components';

const mapState = (state) => {
  const isPro = coreSelectors.getProfile('is_pro')(state);
  const items = isPro
    ? getSidebarProFolders(state)
    : getSidebarClientFolders(state);

  const {
    namespace,
    openedTooltips,
  } = getUiState([
    'namespace',
    'openedTooltips',
  ])(state);

  const marketplace = {
    icon: 'marketplace',
    link: 'marketplace',
    name: 'Marketplace',
  };

  return {
    items: namespace.symbol === 'gymcloud'
      ? items
      : [
        ...items,
        marketplace,
      ],
    namespace,
    openedTooltips,
  };
};

const MainSidebar = () => {
  const {
    items,
    namespace,
    openedTooltips,
  } = useSelector(mapState);
  const dispatch = useDispatch();

  const handleClick = (item) => {
    if (openedTooltips.includes(item.name)) {
      dispatch(
        uiActions.setUiState({
          openedTooltips: openedTooltips.filter(t => t !== item.name),
        }),
      );
    }
  };

  return (
    <Sidebar
      items={items}
      namespace={namespace}
      openedTooltips={openedTooltips}
      onClickItem={handleClick}
    />
  );
};

export default MainSidebar;
